// extracted by mini-css-extract-plugin
export var adsContainer = "GssDD";
export var bottom = "Gd_12";
export var hide = "F_Q0i";